import { render, staticRenderFns } from "./platformstaffSetting.vue?vue&type=template&id=18662329&scoped=true"
import script from "./platformstaffSetting.vue?vue&type=script&lang=js"
export * from "./platformstaffSetting.vue?vue&type=script&lang=js"
import style0 from "./platformstaffSetting.vue?vue&type=style&index=0&id=18662329&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18662329",
  null
  
)

export default component.exports